import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import {ActivatePersonConfirmationDialogComponent} from './activate-person-confirmation-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [ActivatePersonConfirmationDialogComponent],
  imports: [CommonModule, ModalModule.forRoot(),
    TranslateModule.forChild()],
  exports: [ActivatePersonConfirmationDialogComponent],
})
export class ActivatePersonConfirmationDialogModule { }
